<template>
  <div class="start-testing">
    <img
      class="back-icon"
      src="../assets/image/go-back-white.png"
      alt=""
      @click="endTest"
    >
    <div class="subject-progress">
      <div class="progress-title">
        {{ evaluationObj.gaugeAliasName || evaluationObj.gaugeName }}
      </div>
      <div class="progress-box">
        <div class="progress-contain">
          <div
            class="process-content"
            :style="
              'width:' + (subjectNowNumber / subjectAllNumber) * 100 + '%;'
            "
          />
        </div>
        <div class="subject-number">
          {{ subjectNowNumber }}/{{ subjectAllNumber }}
        </div>
      </div>
    </div>
    <div class="subject-aggregate-contain">
      <div class="aggregate-contain-bg" />
      <!-- <div class="subject-aggregate"> -->
      <div
        ref="scollMove"
        class="scoll-contain"
      >
        <div
          v-if="testReset"
          ref="allQuestionBox"
        >
          <!-- 引导语 -->
          <div class="question-type-contain">
            <guide-language :content="evaluationObj.guidingLanguage" />
          </div>
          <div
            v-for="(item, index) in subjectNowList"
            :key="item.questionId"
            class="question-type-contain"
          >
            <!-- 单选 -->
            <single-question
              v-if="item.questionType === '1'"
              :ref="item.questionId"
              :gauge-id="evaluationObj.gaugeId"
              :task-id="evaluationObj.taskId || ''"
              :evaluation-record-id="evaluationRecordId"
              :index="index"
              :question="item"
              :version-num="versionNum"
              @restart="restart"
              @loadNextQuestion="onLoadNextQuestion"
              @banNextQuestionAnswer="onBanNextQuestionAnswer"
              @scrollBottom="onScrollBottom"
              @modifyLastQuestuon="onModifyLastQuestuon"
            />
            <simple-question
              v-if="item.questionType === '2'"
              :ref="item.questionId"
              :gauge-id="evaluationObj.gaugeId"
              :task-id="evaluationObj.taskId || ''"
              :evaluation-record-id="evaluationRecordId"
              :index="index"
              :question="item"
              :version-num="versionNum"
              @restart="restart"
              @loadNextQuestion="onLoadNextQuestion"
              @banNextQuestionAnswer="onBanNextQuestionAnswer"
              @scrollBottom="onScrollBottom"
              @modifyLastQuestuon="onModifyLastQuestuon"
            />
            <video-question
              v-if="item.questionType === '3'"
              :ref="item.questionId"
              :gauge-id="evaluationObj.gaugeId"
              :task-id="evaluationObj.taskId || ''"
              :evaluation-record-id="evaluationRecordId"
              :index="index"
              :question="item"
              :version-num="versionNum"
              @restart="restart"
              @loadNextQuestion="onLoadNextQuestion"
              @banNextQuestionAnswer="onBanNextQuestionAnswer"
              @scrollBottom="onScrollBottom"
              @modifyLastQuestuon="onModifyLastQuestuon"
              @startPlay="startPlayVideo"
            />
            <audio-question
              v-if="item.questionType === '4'"
              :ref="item.questionId"
              :gauge-id="evaluationObj.gaugeId"
              :task-id="evaluationObj.taskId || ''"
              :evaluation-record-id="evaluationRecordId"
              :index="index"
              :question="item"
              :version-num="versionNum"
              @restart="restart"
              @loadNextQuestion="onLoadNextQuestion"
              @banNextQuestionAnswer="onBanNextQuestionAnswer"
              @scrollBottom="onScrollBottom"
              @modifyLastQuestuon="onModifyLastQuestuon"
              @startPlay="startPlayVideo"
              @audioObjectId="onAudioObjectId"
            />
          </div>
          <div
            v-if="showTestEndLanguage"
            class="question-type-contain"
          >
            <old-guide-end
              ref="showTestEndLanguage"
              simple-text="好的，我知道了"
              :gauge-id="evaluationObj.gaugeId"
              :content="evaluationObj.endingLanguage"
              :show-answer.sync="showTestEndLanguageAnswer"
              @loadNextReport="onLoadNextReport"
            />
          </div>
          <div
            v-if="showLookReport"
            class="show-look-report"
            :class="!evaluationObj.taskId ? 'move-center' : ''"
          >
            <div
              class="blue-button-item"
              @click="goReportView"
            >
              查看我的旅程报告
            </div>
            <div
              v-if="!evaluationObj.taskId"
              class="white-button-item"
              @click="testAgain"
            >
              再测一次
            </div>
          </div>
          <div style="height:2px;" />
        </div>
      </div>
      <!-- </div> -->
    </div>

    <!-- 确认结束提醒 -->
    <div
      v-if="showEndDialog"
      key="endtest"
      class="mask-center"
    >
      <div class="test-end-dialog">
        <div class="end-title">
          现在就要结束测评吗？
        </div>
        <div class="end-content">
          下次进入测评时，你可继续作答
        </div>
        <div class="end-button-group">
          <div
            class="leave"
            @click="goHome"
          >
            我要离开了
          </div>
          <div
            class="burl"
            @click="showEndDialog = false"
          >
            再想想
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showVideoPlay"
      id="wrapper"
    >
      <!-- <video style="width:100%;height:100%;" muted :src="imgHost + knowledgeVo.videoUrl" webkit-playsinline='true' playsinline='true' x5-video-player-type="h5" x-webkit-airplay="true" autoplay controls></video> -->
      <div
        v-show="showVideoClose"
        style=""
        class="close-icon"
        @click="stopPlayVideo"
      >
        <img
          src="../assets/image/close-icon.png"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import guideLanguage from "@/components/guideLanguage.vue";
import singleQuestion from "@/components/singleQuestion.vue";
import simpleQuestion from "@/components/simpleQuestion.vue";
import videoQuestion from "@/components/videoQuestion.vue";
import audioQuestion from "@/components/audioQuestion.vue";
import oldGuideEnd from "@/components/oldGuideEnd.vue";
import { mapState } from "vuex";
import { getGaugeEvaluationRecord, clearGaugeEvaluationRecord, saveGaugeEvaluationRecordAll, saveGaugeEvaluationRecord } from "@/assets/utils.js"
export default {
  components: {
    "guide-language": guideLanguage,
    "single-question": singleQuestion,
    "simple-question": simpleQuestion,
    "old-guide-end": oldGuideEnd,
    "video-question": videoQuestion,
    "audio-question": audioQuestion
  },
  data () {
    return {
      evaluationObj: {}, // 量表信息
      subjectAllList: [], // 所有题目集合
      subjectNowList: [], // 页面显示题目集合
      subjectAllNumber: 0, // 题目总数
      subjectNowNumber: 0, // 当前已答题数量
      showEndDialog: false,
      answerQuestionTime: "", // 当前答题的时间
      evaluationRecordId: "", // 题目归属测评Id
      showLookReport: false,
      testReset: true,
      showTestEndLanguage: false, // 是否显示结束语
      showTestEndLanguageAnswer: false, // 是否显示结束语的回复
      lookReportPermission: 1, //查看报告的权限，1是无权限，0是有权限 2:根据预警状态是否可查看，暂定均不可看
      versionNum: 0,
      showVideoPlay: false,
      showVideoClose: false,
      audioObjectId: ''
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  created () {
    this.evaluationObj = {
      completeFlag: "0",
      endingLanguage: "本次测评已结束，请点击下方“好的，我知道了”",
      gaugeAliasDesc: "这是量表简介（学生）",
      gaugeAliasName: "考试焦虑",
      gaugeIcon: "https://test.download.cycore.cn/CSB-decompression-planet-service/2021/11/15/15/179b53bdc4-91d0-4735-883e-6bd3a9f547c7/封面文档.docx",
      gaugeId: "a2d5149283c5428a943ce924e8020d48",
      gaugeName: "心理发展预警量表",
      gaugeTypeName: "社会与适应",
      guidingLanguage: "你好，很高兴在这里见到你！在这里，你会得到你目前面对考试的焦虑程度，以及小星所给出的焦虑缓解练习。 接下来，我们开始探索你的考试焦虑吧！",
      pageNo: "1",
      taskId: "",
      taskName: "七年级任务4",
    }
    this.evaluationObj.completeFlag = window.localStorage.getItem("completeFlag") || "0"
    this.ininData()
  },
  beforeDestroy () {
    clearInterval(this.scollInterval);
  },
  methods: {
    ininData () {
      // 获取所有量表信息---缓存
      this.subjectAllList = [
        {
          "questionId": "2bb6aa5dda2f4ce793a8262789a44562",
          "questionStem": "",
          "questionName": "在考试的时候，你会有什么感受呢？会不会感觉到自己会更容易出汗，焦躁，甚至会影响你正常答题呢？",
          "questionType": "1",
          "limitMinNumber": 1,
          "limitMaxNumber": 1,
          "questionNo": 1,
          "answerList": [
            {
              "businessId": "476d12f66f044534ba1ac5fee4b48c34",
              "optionName": "是的！每次考试都会这样。",
              "optionAnswer": "带着这样的感受考试，真是辛苦了，给你一个大大的拥抱！"
            },
            {
              "businessId": "eb50f27548fe4876a02783724e609c9a",
              "optionName": "是的，发生过很多次。",
              "optionAnswer": null
            },
            {
              "businessId": "4d38f47d621e4e97975adc23a0a0477d",
              "optionName": "有时会这样。",
              "optionAnswer": null
            },
            {
              "businessId": "ca743fd83137412cbb514d4a525fc52d",
              "optionName": "偶尔吧，并不会给我造成很大影响。",
              "optionAnswer": null
            },
            {
              "businessId": "ca743fd83137412cbb514dsdasdasdwe",
              "optionName": "好像从来没有过。",
              "optionAnswer": null
            }
          ],
          "fileList": null
        },
        {
          "questionId": "c90a79dad93f42d4a0f5ccbd898fd7e2",
          "questionStem": "",
          "questionName": "那么，你有没有发现，无论大考还是小考，你总是会担心考砸呢？",
          "questionType": "1",
          "limitMinNumber": 1,
          "limitMaxNumber": 1,
          "questionNo": 2,
          "answerList": [
            {
              "businessId": "1b94a14519ac43199a4367e3f561cf60",
              "optionName": "几乎每次考试都会乱想。。",
              "optionAnswer": "根据调查，大约有65.2%的学生存在不同程度的考试焦虑问题，所以有考试焦虑是很正常的，如果考试焦虑困扰到了你，请记住，你不是一个人在战斗哦！"
            },
            {
              "businessId": "d16b415ff3be41de841058c839244c1f",
              "optionName": "这种情况发生过很多次。",
              "optionAnswer": null
            },
            {
              "businessId": "55aa8e487cd34bde820437e34ea8eefe",
              "optionName": "有时是这样的。",
              "optionAnswer": null
            },
            {
              "businessId": "4f39fa5800d44203a09239218e28a697",
              "optionName": "我偶尔会想一想。",
              "optionAnswer": null
            },
            {
              "businessId": "4f39fa5800d44203a09239218e28a697de",
              "optionName": "好像从来没有过。",
              "optionAnswer": null
            },
          ],
          "fileList": null
        },
        {
          "questionId": "1574616001142144",
          "questionStem": "",
          "questionName": "你会不会一想到要考试了，就非常心慌，心静不下来？",
          "questionType": "1",
          "limitMinNumber": 1,
          "limitMaxNumber": 1,
          "questionNo": 3,
          "answerList": [
            {
              "businessId": "1574616001142145",
              "optionName": "是的，我几乎每次考试都会这样。",
              "optionAnswer": '小星要告诉你一个秘密——在我参加评测的时候，有时会感觉很紧张，甚至连我的“代码胃”都会感觉难受。'
            },
            {
              "businessId": "1574616001142146",
              "optionName": "是的，经常发生。",
              "optionAnswer": null
            },
            {
              "businessId": "1574616001142147",
              "optionName": "有时会这样。",
              "optionAnswer": null
            },
            {
              "businessId": "1574616001142148",
              "optionName": "很少发生，但偶尔也会这样。",
              "optionAnswer": null
            },
            {
              "businessId": "1574616001142148sfsafasf",
              "optionName": "几乎从来没有这种情况。",
              "optionAnswer": null
            }
          ],
          "fileList": null
        },
        {
          "questionId": "1574614843383173",
          "questionStem": "",
          "questionName": "在考试期间，你会不会总是胃口不好，也睡不好觉？",
          "questionType": "1",
          "limitMinNumber": 1,
          "limitMaxNumber": 1,
          "questionNo": 4,
          "answerList": [
            {
              "businessId": "1574614843383174",
              "optionName": "是的，几乎每次都是这样。",
              "optionAnswer": null
            },
            {
              "businessId": "1574614843383175",
              "optionName": "嗯，这种感受还是比较常见。",
              "optionAnswer": null
            },
            {
              "businessId": "1574614843383176",
              "optionName": "有时是这样的。",
              "optionAnswer": null
            },
            {
              "businessId": "1574614843383177",
              "optionName": "偶尔会有这种感觉。",
              "optionAnswer": null
            },
            {
              "businessId": "1574614843383177asdasfasf",
              "optionName": "好像从来没发生过。",
              "optionAnswer": null
            }
          ],
          "fileList": null
        },
        {
          "questionId": "1574614843383178",
          "questionStem": "",
          "questionName": "咳咳，让小星偷偷问问你，有时候你会不会有这样的感觉，就是如果没有考试了，你反而会学得更好？",
          "questionType": "1",
          "limitMinNumber": 1,
          "limitMaxNumber": 1,
          "questionNo": 5,
          "answerList": [
            {
              "businessId": "1574614843383179",
              "optionName": "哈哈哈，我总是这么想。",
              "optionAnswer": null
            },
            {
              "businessId": "1574614843383180",
              "optionName": "我想过很多次。",
              "optionAnswer": null
            },
            {
              "businessId": "1574614843383181",
              "optionName": "还好吧，有时会这么觉得。",
              "optionAnswer": null
            },
            {
              "businessId": "1574614843383182",
              "optionName": "偶尔吧，很少这么想。",
              "optionAnswer": null
            },
            {
              "businessId": "1574614843383182wqeqrtyygsa",
              "optionName": "我没这么想过，考试还是会激励我更努力的。",
              "optionAnswer": null
            }
          ],
          "fileList": null
        }
      ]
      this.subjectAllNumber = this.subjectAllList.length
      this.initRecord()
    },
    initRecord () {
      let record = getGaugeEvaluationRecord("", this.evaluationObj.gaugeId + "_" + this.versionNum, this.evaluationObj.taskId)
      console.log(record)
      if (record && record.recordList && record.recordList.length > 0) {
        this.subjectNowList = record.recordList
        if (this.evaluationObj.completeFlag === "1") { // 当前测评已完成
          this.subjectNowNumber = this.subjectNowList.length
          this.showTestEndLanguage = true;
          this.showTestEndLanguageAnswer = true;
          this.showLookReport = true; // 显示查看报告按钮
          this.$nextTick(() => {
            this.onScrollBottom();
          });
        } else {
          if (this.subjectNowList.length === this.subjectAllList.length) { // 所有题目已回答完，结束语未交互
            this.showTestEndLanguage = true;
            this.subjectNowNumber = this.subjectNowList.length
            this.$nextTick(() => {
              this.showLastQuestionEdit(this.subjectNowList.length - 1);
            });
            setTimeout(() => {
              this.onScrollBottom();
            }, 0);
          } else { // 题目未答完
            //  加载下一题 
            this.subjectNowNumber = record.recordList.length
            this.$nextTick(() => {
              this.showLastQuestionEdit(this.subjectNowList.length - 1);
              this.subjectNowList.push(
                JSON.parse(
                  JSON.stringify(this.subjectAllList[this.subjectNowList.length])
                )
              );
            });
            if (this.subjectNowList.length !== 1) { // 不是从第一题开始滚动到底部
              setTimeout(() => {
                this.onScrollBottom();
              }, 0);
            }
          }
        }
      } else {
        this.subjectNowList.push(
          JSON.parse(
            JSON.stringify(this.subjectAllList[0])
          )
        );
      }
    },
    onAudioObjectId (vaule) {
      this.audioObjectId = vaule
    },
    // 不是依次作答，清空作答，从头开始
    restart () {
      clearGaugeEvaluationRecord("", this.evaluationObj.gaugeId + "_" + this.versionNum, this.evaluationObj.taskId)
      this.subjectNowList = []
      this.subjectNowNumber = 0
      this.subjectAllNumber = this.subjectAllList.length
      this.showTestEndLanguage = false
      this.$nextTick(() => {
        this.initRecord()
      })
    },
    endTest () {
      this.$router.go(-1)
      // if (this.evaluationObj.completeFlag === "1" || this.showLookReport) { // 已完成
      //   this.$router.push({
      //     path: "/home",
      //     query: {
      //       pageNo: this.$route.query.pageNo
      //     }
      //   });
      // } else { // 未完成
      //   this.showEndDialog = true;
      // }
    },
    goHome () {
      // 保存答题时间
      this.$router.push({
        path: "/",
      });
    },
    // 滑动到底部
    onScrollBottom () {
      this.$refs.scollMove.scrollTop = this.$refs.allQuestionBox.offsetHeight;
    },
    // 滑动底部动画
    scollButtomAnimation () {
      if (this.scollInterval) {
        clearInterval(this.scollInterval);
      }
      let clientHeight = this.$refs.scollMove.clientHeight;
      let scrollTop = this.$refs.scollMove.scrollTop;
      this.scollInterval = setInterval(() => {
        try {
          if (
            this.$refs.scollMove.scrollTop + clientHeight <
            this.$refs.allQuestionBox.offsetHeight
          ) {
            if (this.$refs.scollMove.scrollTop < scrollTop) {
              clearInterval(this.scollInterval);
              return;
            }
            this.$refs.scollMove.scrollTop = this.$refs.scollMove.scrollTop + 60;
            scrollTop = this.$refs.scollMove.scrollTop;
          } else {
            clearInterval(this.scollInterval);
          }
        } catch (error) {
          console.log(error)
          clearInterval(this.scollInterval);
        }
      }, 30);
    },
    // 禁止下一题的回答
    onBanNextQuestionAnswer (info) {
      if (this.subjectNowList[info.index + 1]) {
        this.$refs[
          this.subjectNowList[info.index + 1].questionId
        ][0].disabled = true
      } else {
        if (this.showTestEndLanguage) {
          this.$refs.showTestEndLanguage.disabled = true
        }
      }
    },
    // 修改上一题
    onModifyLastQuestuon (info) {
      this.subjectNowNumber--;
      // 移除上一题之后的所有题目
      this.removeAllNextQuextion(info.index);
      this.showLastQuestionEdit(info.index - 1);
    },
    // 移除上一题
    removeAllNextQuextion (index) {
      // 如果显示了结束语隐藏结束语信息
      if (this.showTestEndLanguage) {
        this.$refs['showTestEndLanguage'].startMoveAnimation();
        setTimeout(() => {
          this.showTestEndLanguage = false;
          this.showTestEndLanguageAnswer = false;
          this.showLookReport = false;
        }, 600)
      }
      if (!this.subjectNowList[index + 1]) {
        // 最后一题直接停止
        return;
      }
      this.$refs[
        this.subjectNowList[index + 1].questionId
      ][0].startMoveAnimation();
      setTimeout(() => {
        this.subjectNowList.splice(index + 1, 1);
      }, 600);
    },
    // 加载下一题
    onLoadNextQuestion (info) {
      if (info.index !== 0) {
        this.hideLastQuestionEdit(info.index - 1);
      }
      this.subjectNowNumber++;
      if (this.subjectNowNumber === this.subjectAllNumber) {
        // 题目已全部做完
        this.showTestEndLanguage = true;
        this.$nextTick(() => {
          this.scollButtomAnimation();
        });
      } else {
        // 题目没有做完，加载下一题
        setTimeout(() => {
          let nextQuestionItme = JSON.parse(
            JSON.stringify(this.subjectAllList[info.index + 1])
          );
          this.subjectNowList.push(nextQuestionItme);
          this.$nextTick(() => {
            this.scollButtomAnimation();
          });
        }, 500)

      }
      // this.saveEvalRecord(info);
    },
    // 显示上一题的修改操作
    showLastQuestionEdit (index) {
      if (index === -1) {
        // 没有上一题可以修改
        return;
      }
      if (this.$refs[
        this.subjectNowList[index].questionId
      ][0].question.questionType === "3") {
        this.showLastQuestionEdit(index - 1)
        return
      }
      this.$refs[
        this.subjectNowList[index].questionId
      ][0].showEditLastQuestion = true;
    },
    // 隐藏上一题的修改操作
    hideLastQuestionEdit (index) {
      this.$refs[
        this.subjectNowList[index].questionId
      ][0].showEditLastQuestion = false;
    },
    // 存取最后的结束引导语结果并生产报告
    onLoadNextReport (type) {
      // 禁止最后一题的修改上一题操作
      this.$refs[this.subjectNowList[this.subjectNowList.length - 1].questionId][0].disableModify = true
      // 处理接口需要数据
      window.localStorage.setItem("completeFlag", "1")
      saveGaugeEvaluationRecord("", this.evaluationObj.gaugeId + "_" + this.versionNum, type, 2, "")
      this.hideLastQuestionEdit(this.subjectNowList.length - 1); // 隐藏最后一题的‘修改上一题’操作
      this.showTestEndLanguageAnswer = true;
      this.showLookReport = true;
      this.$nextTick(() => {
        this.scollButtomAnimation();
      });
    },
    // 再测一次
    testAgain () {
      window.localStorage.setItem("completeFlag", "0")
      clearGaugeEvaluationRecord("", this.evaluationObj.gaugeId + "_" + this.versionNum, this.evaluationObj.taskId)
      this.showLookReport = false;
      this.showTestEndLanguage = false;
      this.showTestEndLanguageAnswer = false;
      this.subjectNowNumber = 0;
      this.subjectNowList = [];
      this.$refs.scollMove.scrollTop = 0
      this.$nextTick(() => {
        this.subjectNowList.push(
          JSON.parse(JSON.stringify(this.subjectAllList[0]))
        );
      });
    },
    goReportView () {
      this.$router.push("/evaluationReport")
    },
    startPlayVideo (questionInfo) {
      if (this.audioObjectId && document.getElementById(this.audioObjectId)) {
        document.getElementById(this.audioObjectId).pause()
      }
      this.videoQuestionInfo = questionInfo
      this.showVideoPlay = true
      if (this.player) {
        this.player.pause()
        this.player.destroy(true)
        this.player = null
      }
      this.$nextTick(() => {
        this.player = new window.Player({
          id: 'wrapper',
          url: "https://bj.download.cycore.cn/CSB-decompression-planet-service/fe99d4d3-239d-49b9-9aed-e5dcf8acaa6f/【视频】.考试焦虑的表现和成因-初高中版.mp4",
          width: '100%',
          height: '100%',
          autoplay: true,
          playsinline: false,
          ignores: ['fullscreen'],
          playbackRate: [0.75, 1.0, 1.25, 1.5, 2.0] //传入倍速可选数组
          // pip: true //打开画中画功能
        });
        this.player.on('canplay', () => {
          this.showVideoClose = true
          //事件名称可以在上述查询
        })
        // 浏览器开始在网上寻找媒体数据
        this.player.on('loadstart', () => {
          setTimeout(() => {
            this.showVideoClose = true
          }, 10000)
        })
        this.player.on('error', () => {
          this.showVideoClose = true
          //事件名称可以在上述查询
        })
        this.player.on('play', () => { // 视频播放的时候停止音频播放
          // this.showVideoClose = true
          //事件名称可以在上述查询
          // document.getElementById(this.currentAudioId).pause();
        })
      })
    },
    stopPlayVideo () {
      this.player.destroy(true)
      this.showVideoPlay = false
      this.showVideoClose = false
      this.player = null
      // if (!this.$refs[
      //   this.subjectNowList[this.videoQuestionInfo.index].questionId
      // ][0].isDisabled) {
      //   this.videoQuestionInfo.question.answerInfo = true
      //   saveGaugeEvaluationRecord("", this.evaluationObj.gaugeId + "_" + this.versionNum, this.videoQuestionInfo.question, 1, "")
      //   this.$refs[
      //     this.subjectNowList[this.videoQuestionInfo.index].questionId
      //   ][0].showAnswer = true;
      //   this.$refs[
      //     this.subjectNowList[this.videoQuestionInfo.index].questionId
      //   ][0].isDisabled = true;
      //   this.$nextTick(() => {
      //     this.scollButtomAnimation()
      //     this.onLoadNextQuestion(this.videoQuestionInfo)
      //   })
      // }
    },
  }
};
</script>

<style lang="scss" scoped>
.start-testing {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 205px 80px 44px 80px;
  background: url("../assets/image/gauge-page-bg.png") 0 0 /100% 100%;
  #wrapper {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    // background: brown;
    z-index: 10;
    .close-icon {
      z-index: 1000000000;
      position: absolute;
      top: 20px;
      right: 20px;
      // background:#CCC;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      // border-radius: 50%;
      display: flex;
      align-items: center;
      // box-shadow: 0 0 10px #000;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .back-icon {
    position: absolute;
    left: 75px;
    top: 49px;
    width: 48px;
    height: 48px;
    z-index: 2;
  }
  // 题目进度
  .subject-progress {
    position: fixed;
    top: 35px;
    left: 0;
    width: 100%;
    .progress-title {
      text-align: center;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: #e8f0ff;
      line-height: 48px;
    }
    .progress-box {
      position: relative;
      width: 1094px;
      height: 90px;
      margin: 10px auto 0;
      display: flex;
      align-items: center;
      border-radius: 28px;
      text-align: right;
      background: url("../assets/image/progress-background.png") no-repeat 0 0/100%
        100%;
      .progress-contain {
        position: absolute;
        left: 84px;
        width: 900px;
        height: 32px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        background: #d7dee2;
        overflow: hidden;
        .process-content {
          width: 0%;
          height: 100%;
          border-radius: 16px;
          background: url("../assets/image/progress-img.png") repeat-x;
        }
      }
      .subject-number {
        position: absolute;
        // right: 12px;
        left: 995px;
        font-size: 25px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffc33c;
        line-height: 90px;
        // margin-left: 13px;
        float: right;
      }
    }
  }
  // 题目集合
  .subject-aggregate-contain {
    width: 100%;
    height: 98.83%;
    padding: 40px;
    box-sizing: border-box;
    margin: 0 auto;
    border-radius: 48px;
    // box-shadow: inset 0px 1px 6px 0px rgba(255, 255, 255, 0.96);
    position: relative;
    overflow: hidden;
    .aggregate-contain-bg {
      background: #ffffff;
      opacity: 0.15;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      // box-shadow: inset 0px 1px 6px 0px rgba(255, 255, 255, 0.96);
    }
  }
  // .subject-aggregate {
  //   width: 100%;
  //   height: 100%;
  //   padding: 56px 48px 30px 32px;
  //   box-sizing: border-box;
  //   background: #ffffff;
  //   border-radius: 48px;
  .scoll-contain {
    height: 100%;
    overflow-y: auto;
    position: relative;
    z-index: 2;
    &::-webkit-scrollbar {
      width: 0 !important ;
      height: 0 !important;
      display: none;
    }
  }
  .describe,
  .guide-language {
    display: flex;
    margin-top: 27px;
    .robot {
      width: 43px;
      height: 43px;
      background: pink;
      border-radius: 50%;
    }
    &:first-child {
      margin-top: 0px;
    }
  }
  // 题目样式
  .subject-content {
    margin-left: 13px;
    padding: 17px;
    background: #ffffff;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.02);
    max-width: 670px;
    box-sizing: border-box;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: 26px;
    border-radius: 0 10px 10px;
  }
  // 多选样式
  .multiple-item {
    min-width: 230px;
    margin-top: 20px;
    padding: 9px 13px;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    border-radius: 9px;
    background: #f4f5f7;
    color: #8e8e8e;
  }
  .active-multiple-item {
    color: #ffffff;
    background: #00baff;
  }
  .multiple-item:first-child {
    margin-top: 0;
  }
  // }
  .question-type-contain {
    margin-top: 30px;
    &:first-child {
      margin-top: 0;
    }
  }
  .show-look-report {
    display: flex;
    justify-content: center;
    margin-top: 80px;
    margin-bottom: 10px;
    .blue-button-item {
      width: 520px;
      height: 88px;
      background: #eea300;
      border-radius: 44px;
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 88px;
      &:nth-child(1) {
        margin-right: 50px;
      }
    }
    .white-button-item {
      width: 520px;
      height: 88px;
      box-sizing: border-box;
      background: rgba(251, 252, 255, 0.2);
      border-radius: 44px;
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #e8f0ff;
      line-height: 88px;
      margin-left: 50px;
    }
  }
  .move-center {
    .blue-button-item {
      margin: 0;
    }
  }
  .test-end-dialog {
    width: 600px;
    background: #ffffff;
    box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 45px;
    box-sizing: border-box;
    padding: 52px 60px 58px;
    .end-title {
      font-weight: 700;
      font-size: 36px;
      line-height: 50px;
      text-align: center;
      color: #262626;
    }
    .end-content {
      margin-top: 20px;
    }
    .end-button-group {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      & > div {
        width: 228px;
        height: 80px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 40px;
      }
      .leave {
        border: 1px solid #d9dce2;
      }
      .burl {
        background: #00baff;
        color: #ffffff;
      }
    }
    .feebback-select-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .feebback-select-item {
        height: 24px;
        img {
          width: 21px;
          height: 21px;
        }
      }
    }
  }
  .feedback-dialog {
    width: 1044px;
    height: 598px;
    padding: 60px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 45px;
    .feebback-title {
      font-weight: 700;
      font-size: 36px;
      line-height: 50px;
      text-align: center;
    }
    .feebback-content {
      margin-top: 50px;
    }
    .feebback-select-list {
      margin-top: 18px;
      display: flex;
      align-items: center;
      .feebback-select-item {
        line-height: 45px;
        margin-right: 35px;
        img {
          width: 40px;
          height: 40px;
          vertical-align: text-bottom;
          margin-right: 15px;
        }
      }
    }
    .feebback-button-contain {
      display: flex;
      justify-content: center;
      margin-top: 50px;
      .disable-submit {
        background: #f4f5f7;
        color: #8e8e8e;
      }
    }
    .feebback-submit {
      width: 433px;
      height: 80px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 40px;
      background: #00baff;
      color: #ffffff;
    }
  }
  .opinion-box {
    width: 750px;
    background: #ffffff;
    border-radius: 13px;
    box-sizing: border-box;
    padding: 50px 53px 50px;
    .title {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: #262626;
      line-height: 50px;
      text-align: center;
    }
    .desc-text {
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #595959;
      line-height: 45px;
      margin-top: 20px;
    }
    .button-group {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        width: 300px;
        height: 70px;
        border-radius: 40px;
        line-height: 70px;
        box-sizing: border-box;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        outline: none;
        border: none;
      }
      .burl-button {
        color: #262626;
        background: #fff;
        border: 1px solid #d9dce2;
      }
      .submit-button {
        color: #ffffff;
        background: #00baff;
      }
    }
  }
  .show-photo-remark {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    // background: rgba(0,0,0,0.4);
    .photo-text {
      position: absolute;
      left: 25px;
      top: 20px;
      width: 67px;
      height: 67px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 47px;
        height: 47px;
        border-radius: 50%;
      }
    }
    .remark-conmon {
      position: absolute;
      height: 80px;
      box-sizing: border-box;
      padding: 17px 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #00baff;
      border-top-right-radius: 40px;
      // border-bottom-right-radius:22px;
      border-bottom-left-radius: 40px;
      line-height: 80px;
      .guild-start1 {
        width: 32px;
        height: 32px;
        position: absolute;
        right: -2px;
        top: -38px;
      }
      .guild-start2 {
        width: 24px;
        height: 24px;
        position: absolute;
        right: -32px;
        top: -5px;
      }
      p {
        color: #fcfcfc;
        font-size: 32px;
      }
    }
    .photo-remark {
      top: 265px;
      left: 129px;
    }
    .module-text {
      position: absolute;
      top: 130px;
      left: 20px;
      height: 30px;
      width: 100px;
      background: rgba(255, 255, 255, 1);
      border-radius: 15px;
      line-height: 30px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: #262626;
    }
    .module-remark {
      top: 403px;
      left: 219px;
    }
    .tools-remark {
      position: absolute;
      top: 630px;
      left: 220px;
    }
    .knowledge-remark {
      position: absolute;
      top: 844px;
      left: 220px;
    }
    .more-tools2 {
      position: fixed;
      right: 17px;
      bottom: 30px;
      width: 84px;
      height: 84px;
      border-radius: 50%;
      background: #ffffff;
      opacity: 0.9;
    }
  }
}
.guide-language-type {
  position: relative;
  left: 0;
  opacity: 1;
  transition: left 0.5s, opacity 0.5s;
  .describe,
  .guide-language {
    display: flex;
    margin-top: 30px;
    .robot {
      width: 88px;
      height: 88px;
      // background: pink;
      border-radius: 50%;
    }
    &:first-child {
      margin-top: 0px;
    }
  }
  .active-multiple-item {
    color: #ffffff;
    background: #00baff;
  }
  .multiple-item:first-child {
    margin-top: 0;
  }
}
</style>
